module.exports = __webpack_public_path__ + "img/alter-ego_16-9_poster.de99459.jpg";